export default __webpack_public_path__ + "85ddc595870b5acaf6e793f383605b3e.jpg";